import { createBrowserHistory } from 'history';

export const URL_PREFIX = '/v2';

export default createBrowserHistory({
    basename: process.env.NODE_ENV === 'test' ? '' : URL_PREFIX,
});

export type { Location } from 'history';
